import { defineMessage, MessageDescriptor } from 'react-intl';

import CommonMessages from '~/core/commonMessages';
import { PlayerStatAbbrev, PlayerStatNames } from '~/core/enums';

import { ClinchIndicator } from '../../enums';
import StandingsMessages from '../../messages';

export type LegendItem = {
    definition: MessageDescriptor;
    key: MessageDescriptor;
    isEliminatedIndicator?: boolean;
};

const legendMessages: Array<LegendItem> = [
    {
        definition: defineMessage({
            description: 'Denotes that symbol means Clinched Playoff spot',
            defaultMessage: 'Clinched Playoff spot',
        }),
        key: StandingsMessages.table.cells.clinchIndicators[ClinchIndicator.playoffClinch],
    },
    {
        definition: defineMessage({
            description: 'Denotes that symbol means Clinched Division spot',
            defaultMessage: 'Clinched Division',
        }),
        key: StandingsMessages.table.cells.clinchIndicators[ClinchIndicator.divisionClinch],
    },
    {
        definition: defineMessage({
            description: "Denotes that symbol means Presidents' Trophy",
            defaultMessage: "Presidents' Trophy",
        }),
        key: StandingsMessages.table.cells.clinchIndicators[ClinchIndicator.presidentsTrophy],
    },
    {
        definition: defineMessage({
            description: 'Denotes that symbol means Clinched Conference',
            defaultMessage: 'Clinched Conference',
        }),
        key: StandingsMessages.table.cells.clinchIndicators[ClinchIndicator.conferenceClinch],
    },
    {
        definition: StandingsMessages.table.cells.clinchAriaDescriptions[ClinchIndicator.eliminated],
        key: StandingsMessages.table.cells.clinchIndicators[ClinchIndicator.eliminated],
    },

    {
        definition: CommonMessages.statsDescriptions.long[PlayerStatNames.gamesStarted],
        key: CommonMessages.statsDescriptions.abbreviations[PlayerStatAbbrev.gamesPlayed],
    },
    {
        definition: defineMessage({
            description: 'Denotes that symbol means Wins',
            defaultMessage: 'Wins (worth two points)',
        }),
        key: CommonMessages.statsDescriptions.abbreviations[PlayerStatAbbrev.wins],
    },
    {
        definition: defineMessage({
            description: 'Denotes that symbol means Losses',
            defaultMessage: 'Losses (worth zero points)',
        }),
        key: CommonMessages.statsDescriptions.abbreviations[PlayerStatAbbrev.losses],
    },
    {
        definition: defineMessage({
            description: 'Denotes that symbol means Overtime or Shootout Losses',
            defaultMessage: 'OT/Shootout losses (worth one point)',
        }),
        key: CommonMessages.statsDescriptions.abbreviations[PlayerStatAbbrev.overtimeLosses],
    },
    {
        definition: defineMessage({
            description: 'Denotes that symbol means Points',
            defaultMessage: 'Points',
        }),
        key: StandingsMessages.table.headers.abbrs.points,
    },
    {
        definition: defineMessage({
            description: 'Denotes that symbol means Points Percentage',
            defaultMessage: 'Points Percentage',
        }),
        key: StandingsMessages.table.headers.abbrs.pointsPercentage,
    },
    {
        definition: defineMessage({
            description: 'Denotes that symbol means Regulation Wins',
            defaultMessage: 'Regulation Wins',
        }),
        key: StandingsMessages.table.headers.abbrs.regulationWins,
    },
    {
        definition: defineMessage({
            description: 'Denotes that symbol means Regulation plus Overtime Wins',
            defaultMessage: 'Regulation plus Overtime Wins',
        }),
        key: StandingsMessages.table.headers.abbrs.regulationPlusOtWins,
    },
    {
        definition: defineMessage({
            description: 'Denotes that symbol means Goals For',
            defaultMessage: 'Goals For',
        }),
        key: StandingsMessages.table.headers.abbrs.goalsFor,
    },
    {
        definition: defineMessage({
            description: 'Denotes that symbol means Goals Against',
            defaultMessage: 'Goals Against',
        }),
        key: StandingsMessages.table.headers.abbrs.goalsAgainst,
    },
    {
        definition: defineMessage({
            description: 'Denotes that symbol means Goal Differential',
            defaultMessage: 'Goal Differential',
        }),
        key: StandingsMessages.table.headers.abbrs.goalDifferential,
    },
    {
        definition: defineMessage({
            description: 'Denotes that symbol means Home Record',
            defaultMessage: 'Home Record',
        }),
        key: StandingsMessages.table.headers.home,
    },
    {
        definition: defineMessage({
            description: 'Denotes that symbol means Away Record',
            defaultMessage: 'Away Record',
        }),
        key: StandingsMessages.table.headers.away,
    },
    {
        definition: defineMessage({
            description: 'Denotes that symbol means games decided by Shootout',
            defaultMessage: 'Record in games decided by Shootout',
        }),
        key: StandingsMessages.table.headers.abbrs.shootout,
    },
    {
        definition: defineMessage({
            description: 'Denotes that symbol means Record in last ten games',
            defaultMessage: 'Record in last ten games',
        }),
        key: StandingsMessages.table.headers.abbrs.lastTen,
    },
    {
        definition: defineMessage({
            description: 'Denotes that symbol means Streak',
            defaultMessage: 'Streak',
        }),
        key: StandingsMessages.table.headers.abbrs.streak,
    },
];

export default legendMessages;
